export default "__VITE_ASSET__G$2ViW0X__"